import { defineComponent as _defineComponent } from 'vue';
import { BTab, BTabs } from "bootstrap-vue";
import FromFileOrUrl from "@/components/Workflow/Import/FromFileOrUrl.vue";
import TrsImport from "@/components/Workflow/Import/TrsImport.vue";
import TrsSearch from "@/components/Workflow/Import/TrsSearch.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowImport',
    setup(__props) {
        return { __sfc: true, BTab, BTabs, FromFileOrUrl, TrsImport, TrsSearch };
    }
});
